import { defineMessages } from 'react-intl-next';

export default defineMessages({
	iconLabel: {
		id: 'team-button.icon.label',
		defaultMessage: 'Team button',
		description: 'Label for the team button icon',
	},
});
